import type { PassengerDetails } from "src/PassengerDetailsProvider";
import type { MessageDescriptor } from "react-intl";
import messages from "./PassengerPicker.message";

const MIN_ADULT_AGE = 18;

export function isValidPassengerDetails(details: PassengerDetails) {
  return getPassengerDetailsErrors(details).length === 0;
}

export function getPassengerDetailsErrors(details: PassengerDetails) {
  let errors: MessageDescriptor[] = [];

  const hasAdult = details.some(
    ({ type, age }) => type !== "youth" || Number(age) >= MIN_ADULT_AGE,
  );
  if (!hasAdult) {
    errors.push(messages.minimumPassengerMessage);
  }

  const hasAges = details.every(
    ({ type, age }) => type === "adult" || age !== "",
  );
  if (!hasAges) {
    errors.push(messages.agesRequiredMessage);
  }

  return errors;
}
